import React from 'react'
import { useSelector } from 'react-redux'

import BaseEntity from 'app/components/BaseEntity'
import constants from 'app/constants'
import {
  fetchPlannerGradeGroupData,
  updatePlannerData
} from 'app/store/actions/lessonPlannerEntity'

import { columns } from './config'

/** Grade groups admin (Toddler / Pre-nursery / Nursery / K1). */
const GradeGroups = () => {
  const data = useSelector(
    (state) => state.lessonPlannerEntityReducer.plannerGradeGroupData
  )

  return (
    <BaseEntity
      entity={constants.PLANNER_GRADE_GROUP}
      label={constants.PLANNER_GRADE_GROUP_LABEL}
      columns={columns}
      data={data}
      fetchData={fetchPlannerGradeGroupData}
      updateEntityData={updatePlannerData}
    />
  )
}

export default GradeGroups
